export const stringifyQueryParams = (queryParams) => {
    return Object.entries(queryParams)
        .sort()
        .map(([key, value]) => {
        const encodedKey = encodeURIComponent(key);
        if (value === undefined) {
            return "";
        }
        if (value === null) {
            return `${encodedKey}=null`;
        }
        if (Array.isArray(value)) {
            const encodedArrayKey = encodeURIComponent(`${key}[]`);
            return value.length > 0
                ? `${encodedArrayKey}=${value.map(encodeURIComponent).join(",")}`
                : "";
        }
        if (typeof value === "string" ||
            typeof value === "number" ||
            typeof value === "boolean") {
            return `${encodedKey}=${encodeURIComponent(value)}`;
        }
        return "";
    })
        .filter((param) => param.length > 0)
        .join("&");
};
//# sourceMappingURL=stringifyQueryParams.js.map